"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAdminRole = exports.getRoleName = exports.ROLE_NAMES = void 0;
const UserRoles = {
    SYS_ADMIN: 'SYS_ADMIN',
    SYS_ADMIN_READ: 'SYS_ADMIN_READ',
    ADMIN: 'ADMIN',
    PROJECT_MANAGER: 'PROJECT_MANAGER',
    LINGUIST: 'LINGUIST',
    GUEST: 'GUEST',
    SUBMITTER: 'SUBMITTER',
};
exports.default = UserRoles;
exports.ROLE_NAMES = {
    SYS_ADMIN: 'System Administrator',
    SYS_ADMIN_READ: 'System Administrator (Read)',
    ADMIN: 'Admin',
    PROJECT_MANAGER: 'Project Manager',
    LINGUIST: 'Linguist',
    GUEST: 'Guest',
    SUBMITTER: 'Submitter',
};
exports.getRoleName = role => {
    return exports.ROLE_NAMES[role] || 'Unknown';
};
exports.isAdminRole = role => {
    return (role === UserRoles.SYS_ADMIN || role === UserRoles.SYS_ADMIN_READ || role === UserRoles.ADMIN);
};
//# sourceMappingURL=UserRoles.js.map